import { ExclamationCircleOutlined } from "@ant-design/icons";
import { Button, ConfigProvider, DatePicker, Form, Input, Popover, Radio, Select, Space, message } from "antd";
import React, { useEffect, useState } from "react";

import "antd/dist/antd.css";
import moment from "moment";
import "moment/locale/fr";
import { connect } from "react-redux";
import { Link, Redirect } from "react-router-dom";
import { bindActionCreators } from "redux";
import { requestApiAddGuestByGuest } from "../../store/actions/actions";

import styles from "./RequestAccount.module.css";

import i18n from "i18next";
import { withTranslation } from "react-i18next";
import ModalConfirm from "./ModalConfirm";

const { Option } = Select;

const today = `${moment()._d.getDate()}/${moment()._d.getMonth() + 1}/${moment()._d.getFullYear()}`;

const RequestAccount = (props) => {
  useEffect(() => {
    document.title = `${props.t("request_account.title")} - Wifi Guest`;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [finish, setFinish] = useState(false);
  const [locale, setLocale] = useState();
  const [language, setLanguage] = useState();
  const [form] = Form.useForm();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setLanguage(i18n.language);
    if (language === "fr") {
      const data = require("antd/lib/locale/fr_FR");
      setLocale(data.default);
    } else {
      setLocale("en");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language, language]);

  if (finish) {
    return <Redirect to={"/home"} />;
  }

  const callbackAddGuest = (res) => {
    if (res === 201 || res === 200) {
      setFinish(true);
      message.success(<span style={{ marginLeft: "5px" }}>{props.t("request_account.server.success")}</span>);
    } else {
      message.error(<span style={{ marginLeft: "5px" }}>{props.t("request_account.server.error")}</span>);
    }
  };

  const requestAccountHandler = (values) => {
    let date = values.startAt._d;

    props.requestApiAddGuestByGuest({
      body: {
        guest: values.email,
        firstName: values.firstName,
        lastName: values.name,
        company: values.company,
        sponsor: values.emailSponsor,
        startAt: moment(`${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`, "DD/MM/YYYY").format("YYYY-MM-DD"),
        validity_period: (values.duration * 86400).toString(),
        language: values.language,
      },
      callback: (e) => {
        callbackAddGuest(e);
      },
    });
  };

  const { t } = props;

  return (
    <div className={styles.form_container}>
      <h2>{t("request_account.title")}</h2>
      <ConfigProvider locale={locale}>
        <Form
          name="request_form"
          initialValues={{
            remember: true,
            startAt: moment(today, "DD/MM/YYYY"),
            duration: "1",
            language: "fr",
          }}
          onFinish={requestAccountHandler}
          autoComplete="off"
          layout="vertical"
          className={styles.form}
          form={form}
        >
          <Popover
            trigger={["hover", "click"]}
            content={
              <p style={{ maxWidth: 600 }}>
                <div
                  dangerouslySetInnerHTML={{
                    __html: t("request_account.rgpd"),
                  }}
                />
              </p>
            }
          >
            <p className={styles.rgpd}>
              <ExclamationCircleOutlined
                style={{
                  marginRight: 5,
                  color: "#1890ff",
                  fontSize: 12,
                  size: 12,
                }}
              />
              {t("request_account.rgpd")}
            </p>
          </Popover>
          <div className={styles.form_flex}>
            <Form.Item
              label={t("request_account.label.firstname")}
              name="firstName"
              className={styles.input_item}
              rules={[
                {
                  required: true,
                  message: t("request_account.validation.firstname"),
                },
              ]}
            >
              <Input placeholder={t("request_account.placeholder.firstname")} />
            </Form.Item>
            <Form.Item
              label={t("request_account.label.lastname")}
              name="name"
              className={styles.input_item}
              rules={[
                {
                  required: true,
                  message: t("request_account.validation.lastname"),
                },
              ]}
            >
              <Input placeholder={t("request_account.placeholder.lastname")} />
            </Form.Item>
          </div>
          <Form.Item
            label={t("request_account.label.mail")}
            name="email"
            validateTrigger="onBlur"
            rules={[
              {
                required: true,
                message: t("request_account.validation.mail"),
                type: "email",
              },
            ]}
          >
            <Input placeholder={t("request_account.placeholder.mail")} />
          </Form.Item>
          <Form.Item
            label={t("request_account.label.mail_sponsor")}
            name="emailSponsor"
            validateTrigger="onBlur"
            rules={[
              {
                required: true,
                message: t("request_account.validation.mail_sponsor"),
                type: "email",
              },
            ]}
          >
            <Input placeholder={t("request_account.placeholder.mail_sponsor")} />
          </Form.Item>

          <Form.Item
            label="Entreprise"
            name="company"
            rules={[
              {
                required: true,
                message: t("request_account.validation.company"),
              },
            ]}
          >
            <Input placeholder={t("request_account.placeholder.company")} />
          </Form.Item>
          <div className={styles.form_flex}>
            <Form.Item
              name="startAt"
              label={t("request_account.label.startAt")}
              rules={[
                {
                  required: true,
                  message: t("request_account.validation.date"),
                },
              ]}
              className={styles.input_date}
            >
              <DatePicker className={styles.input_date} placeholder={moment().format("DD/MM/YYYY")} locale={locale} format={t("date_format")} />
            </Form.Item>

            <Form.Item name="duration" label={t("request_account.label.duration")} rules={[{ required: true }]} className={styles.input_duration}>
              <Select>
                <Option value="1">1 {t("request_account.select.day")}</Option>
                <Option value="2">2 {t("request_account.select.days")}</Option>
                <Option value="7">7 {t("request_account.select.days")}</Option>
              </Select>
            </Form.Item>
            <Form.Item
              className={styles.form__group__item}
              style={{ width: "100%" }}
              name="language"
              label={t("admin.users.edit.label.language")}
              rules={[
                {
                  required: true,
                  message: t("admin.users.edit.validation.language"),
                },
              ]}
            >
              <Radio.Group>
                <Space>
                  <Radio value={"fr"}>{t("admin.users.edit.label.french")}</Radio>
                  <Radio value={"en"}>{t("admin.users.edit.label.english")}</Radio>
                </Space>
              </Radio.Group>
            </Form.Item>
          </div>
          <div className={styles.form_footer}>
            <div className={styles.form_footer_mandatory}>
              <p> {t("request_account.label.mandatory")}</p>
            </div>
            <div className={styles.form_button}>
              <Form.Item>
                <Link to="/home">
                  <Button danger size="large">
                    {t("request_account.button.cancel")}
                  </Button>
                </Link>
              </Form.Item>
              <Form.Item>
                <Button
                  htmlType="button"
                  type="primary"
                  size="large"
                  onClick={() => {
                    form.validateFields().then(() => {
                      setOpen(true);
                    });
                  }}
                >
                  {t("request_account.button.continue")}
                </Button>
              </Form.Item>
            </div>
          </div>
        </Form>
        <ModalConfirm open={open} setOpen={setOpen} onFinish={form.submit} />
      </ConfigProvider>
    </div>
  );
};

const mapStateToProps = (state) => ({ data: state.data });

const mapDispatchToProps = (dispatch) => bindActionCreators({ requestApiAddGuestByGuest }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(RequestAccount));
